import React, {useEffect} from 'react';
import {Redirect} from 'react-router-dom';
import {flashMessage} from 'shared/actions/notifications';
import {useDispatch} from 'react-redux';

interface Props {
  redirectTo: string;
  message: string;
  type: 'error' | 'success';
}

const MessageAndRedirect = ({redirectTo, message, type = 'error'}: Props) => {
  const dispatch = useDispatch();
  const showMessage = () => dispatch(flashMessage(message, type, {}, 5000));

  useEffect(() => {
    showMessage();
  }, [showMessage]);

  return <Redirect path="*" to={redirectTo} />;
};

export default MessageAndRedirect;
